const rtlLanguages = ["ar", "fa", "he"];

export function getLanguageDirection(language: string | undefined) {
  if (!language) return "ltr";
  if (rtlLanguages.includes(language)) return "rtl";
  return "ltr";
}
